import { NextImage } from '../NextImage'
import { Row } from '../Grid'

export const Avatar = ({ psycho, ...props }) => (
  <Row {...props}>
    <NextImage
      width={130}
      height={130}
      layout='intrinsic'
      borderRadius='100%'
      src={psycho.social_thumb || '/static/images/psicologo-sem-foto.png'}
      alt={`Imagem do perfil do psicólogo ${psycho.name}`}
      itemprop='image'
      priority
      style={{ cursor: 'pointer' }}
    />
  </Row>
)
